module.exports = __webpack_public_path__ + "static/img/LOGO.da9e08a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/Lifegoeson/LOGO.png
// module id = /J4H
// module chunks = 0